import {useRecentlyAdded} from 'hooks/RecentlyAdded';
import React from 'react';
import {Items} from 'shared/components/Product/Items';

interface RecentItemsProps {
    isProduct: boolean;
    setError?: (errors: string[]) => void;
}

export const RecentItems = ({isProduct, setError}: RecentItemsProps) => {
    const {items} = useRecentlyAdded(isProduct, setError);

    if (items.length) {
        return (
            <Items
                items={items}
                title="Recently Added"
                noHr={false}
                isProduct={isProduct}
                setError={setError}
                showScrollButton={false}
            />
        );
    }

    return null;
};
